import api from '../../plugins/api';

// POST /crm/cars/uploadStock/commit â Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´ÐµÐ½Ð¸Ðµ Ð²ÑÑÑÐ½ÑÑ Ð¸ÑÐ¿ÑÐ°Ð²Ð»ÐµÐ½Ð½ÑÑ ÑÑÑÐ¾Ðº ÑÑÐ¾ÐºÐ°,
// ÐºÐ¾ÑÐ¾ÑÑÐµ Ð½Ðµ Ð¿ÑÐ¾ÑÐ»Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ Ð¸Ð¼Ð¿Ð¾ÑÑ (ÑÐ¼. uploadStock -> pendingRows/sessionId)
const commitStockCorrections = (sessionId, rows) => {
  return api.post('/api/crm/cars/uploadStock/commit', { sessionId, rows });
};

export default commitStockCorrections;
